import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Wishlist from "@/pages/Wishlist";
import Compare from "@/pages/Compare";
import OrderDetail from "@/pages/OrderDetail";
import StaticPage from "@/pages/StaticPage";
import CompareBar from "@/components/CompareBar";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <CompareBar />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/produtos" element={<Layout><Products /></Layout>} />
          <Route path="/produto/:slug" element={<Layout><ProductDetail /></Layout>} />
          <Route path="/categorias" element={<Layout><StaticPage /></Layout>} />
          <Route path="/novidades" element={<Layout><Products /></Layout>} />
          <Route path="/promocoes" element={<Layout><Products /></Layout>} />
          <Route path="/sobre" element={<Layout><StaticPage /></Layout>} />
          <Route path="/contacto" element={<Layout><Contact /></Layout>} />
          <Route path="/carrinho" element={<Layout><Cart /></Layout>} />
          <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
          <Route path="/login" element={<Layout><Login /></Layout>} />
          <Route path="/registar" element={<Layout><Register /></Layout>} />
          <Route path="/conta" element={<Layout><Account /></Layout>} />
          <Route path="/favoritos" element={<Layout><Wishlist /></Layout>} />
          <Route path="/comparar" element={<Layout><Compare /></Layout>} />
          <Route path="/encomenda/:number" element={<Layout><OrderDetail /></Layout>} />
          <Route path="/admin" element={<Layout><Admin /></Layout>} />
          <Route path="/politicas/:slug" element={<Layout><StaticPage /></Layout>} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
